import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EdgeConnectionRecord } from '@models/edge/edge-connection-record';
import { EdgeTransactionRecord } from '@models/edge/edge-transaction-record';
import { PageResult } from '@models/requests/page-result.interface';
import { IServerSideGetRowsRequest } from 'ag-grid-enterprise';
import { map, Observable } from 'rxjs';
import BaseApiService from "../../../shared/services/base/base-api.service";

@Injectable()
export class SuperuserApiService extends BaseApiService {
  getEdgeTransactions(request: IServerSideGetRowsRequest, search?: string): Observable<PageResult<EdgeTransactionRecord>> {
    let params = new HttpParams();

    if (search) {
      params = params.append('search', search);
    }

    return this.api.post<PageResult<EdgeTransactionRecord>>(`${ this.apiUrl }/superuser/edge/transactions/grid`, request, { params: params })
      .pipe(
        map((data) => {
          data.records = data.records.map(d => new EdgeTransactionRecord(d));
          return data;
        })
      );
  }

  getEdgeConnections(request: IServerSideGetRowsRequest): Observable<PageResult<EdgeConnectionRecord>> {
    return this.api.post<PageResult<EdgeConnectionRecord>>(`${ this.apiUrl }/superuser/edge/connection-attempts/grid`, request)
      .pipe(
        map(data => {
          data.records = data.records.map(d => new EdgeConnectionRecord(d));
          return data;
        })
      );
  }

  listOrganisationNames(): Observable<Map<string, string>> {
    return this.api.get<Record<string, string>>(`${ this.apiUrl }/superuser/organisations`)
      .pipe(
        map((data: Record<string, string>) => {
          const resultMap = new Map<string, string>();

          Object.keys(data).forEach(key => {
            resultMap.set(key, data[key]);
          });

          return resultMap;
        })
      );
  }

  getTransactionText(transactionId: string): Observable<string> {
    return this.api.get(`${ this.apiUrl }/superuser/edge/transaction/${ transactionId }/text`, { responseType: 'text' });
  }

  downloadTransaction(transactionId: string): Observable<string> {
    return this.api.get<string>(`${ this.apiUrl }/superuser/edge/transaction/${ transactionId }`);
  }

  reprocessTransaction(transactionId: string): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/superuser/edge/transaction/${ transactionId }/reprocess`, {});
  }

  publishOrganisationSignal(orgId: string, useSecondary: boolean): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/superuser/edge/signal/${ orgId }`, {}, { params: { useSecondary: useSecondary.toString() } });
  }
}
